import defaultReducer from "./defaultReducer";

export const PROCESS_PERIOD_MODAL_TYPE = "PROCESS_PERIOD_MODAL_TYPE";

export const ProcessPeriodModalDefaultState = {
  open: false,
  fromDate: "2024-01-01",
  toDate: "2024-03-31",
  data: [],
};

export default defaultReducer(
  PROCESS_PERIOD_MODAL_TYPE,
  ProcessPeriodModalDefaultState,
);
